import React from 'react';
import PropTypes from 'prop-types';
import { InputWrapper, Input, Label } from './styles.js';

export const Checkbox = ({
  name,
  onChange,
  onBlur,
  label,
  checked,
  disabled,
}) => {
  return (
    <InputWrapper>
      <Input
        id={name}
        name={name}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={() => onChange(!checked)}
        onBlur={() => onBlur?.()}
      />

      <Label htmlFor={name}>{label}</Label>
    </InputWrapper>
  );
};

Checkbox.displayName = 'Checkbox';

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node,
};
